import type { WeeklyNote } from '@/libs/interfaces'

import { MOCK_STORE_ID_1, MOCK_STORE_ID_2 } from './seed'

export const mockWeeklyNotes: WeeklyNote[] = [
  {
    weekNoteID: 'weekly-note-1',
    storeID: MOCK_STORE_ID_1,
    week: '2026-W26',
    note: 'Strong week overall, capacity fully booked Tuesday through Thursday.',
    createdAt: '2026-06-22T08:00:00Z',
    updatedAt: '2026-06-29T08:00:00Z',
  },
  {
    weekNoteID: 'weekly-note-2',
    storeID: MOCK_STORE_ID_2,
    week: '2026-W26',
    note: 'Onboarding a new technician, expect slightly longer turnaround times.',
    createdAt: '2026-06-22T08:00:00Z',
    updatedAt: '2026-06-27T08:00:00Z',
  },
]
